
  .responsive2284599289__root .AddButton1524782716__root {
    border: 1px dashed #cfd1dc;
    background-color: #f4f5f8;
  }

  .responsive2284599289__root .AddButton1524782716__root:hover:not(:disabled) {
    background-color: #dce9ff;
  }

  .responsive2284599289__root .AddButton1524782716__root:focus {
    outline: 2px solid #cfd1dc;
  }

  .responsive2284599289__root .AddButton1524782716__root:disabled {
    border-color: #e5e5e5;
  }

  .responsive2284599289__root .AddButton1524782716__plusIcon > svg {
    fill: #116dff;
  }

  .responsive2284599289__root .AddButton1524782716__root:disabled .AddButton1524782716__plusIcon > svg {
    fill: #767676;
  }

/* st-namespace-reference="../../../../src/atoms/AddButton/AddButton.responsive.st.css" */